export const FETCH_APPOINTMENT_SERVICE_TYPES =
  'FETCH_APPOINTMENT_SERVICE_TYPES';
export const FETCH_APPOINTMENT_SERVICE_TYPES_SUCCESS =
  'FETCH_APPOINTMENT_SERVICE_TYPES_SUCCESS';
export const FETCH_APPOINTMENT_SERVICE_TYPES_FAILURE =
  'FETCH_APPOINTMENT_SERVICE_TYPES_FAILURE';
